// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2033":"f0288c578c3dc240","6749":"64b23e9dacaf2a38"}[chunkId] + ".js";
};